import '../Sass/App.scss';
import React, { useState, useRef } from 'react';

export function VirusIntegrity(props) {

    const integrityArray = [...Array(props.maxIntegrity+1).keys()].reverse()
    const [currentIntegrity, setCurrentIntegrity] = useState(props.currentIntegrity)

    function changeViralIntegrity(newValue) {
        setCurrentIntegrity(newValue)
    }

    return (
        <div className="virus-integrity-box">
            { integrityArray.map((integrity, index) => 
                ( <div className="virus-integrity-tick" onClick={() => changeViralIntegrity(integrity)} style={{width: (props.cardWidth - (props.maxIntegrity+1)) / (props.maxIntegrity+1)}} key={index}>
                    <div className="virus-integrity-counter" style={ currentIntegrity == integrity ? {visibility: 'visible', left: (((props.cardWidth - (props.maxIntegrity+1)) / (props.maxIntegrity+1)) / 2)-10} : null }></div>
                    <div className="virus-integrity-number" style={{fontSize: props.cardWidth / 50}}>{integrity}</div>
                </div> )
            )}
        </div>
    )
}
